<template>
  <b-modal
      data-test-path="dialog-help"
      id="bv-modal-help"
      @hide="hide"
      ok-title="ok"
      :ok-only="true"
      ok-variant="plm-primary"
      ref="modal"
  >
    <template v-slot:modal-title>
      {{ title }}
    </template>
    <div class="d-block pl-2 pl-sm-4" v-html="message">
    </div>

    <template #modal-footer="{close}">
      <b-container class="pl-0">
        <b-row >
          <b-col class=" pr-0 text-right">
            <b-button variant="plm-primary" @click="hide">
              <font-awesome-icon icon="check" class="mr-1"/> Ok
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </template>

  </b-modal>

</template>

<script>
export default {
  name: "HelpDialog",
  async beforeMount() {
  },
  methods: {
    async hide() {
      this.$refs.modal.hide();
    },

  },
  data: () => ({
    title: "title",
    message: "message",
  })
}
</script>
